import { ConversationChannelTypeExtended } from '@provision/chat-utils';
import type { IconLibrary } from 'src/components/DynamicIcon/dynamic-icon';

interface ConversationIconConfig {
  name: string;
  library?: IconLibrary;
}

const getConversationIconConfig = (
  channel: ConversationChannelTypeExtended,
): ConversationIconConfig => {
  switch (channel) {
    case ConversationChannelTypeExtended.Email:
      return { name: 'mail', library: 'lucide' };
    case ConversationChannelTypeExtended.Chat:
      return { name: 'message-circle', library: 'lucide' };
    case ConversationChannelTypeExtended.InternalNote:
      return { name: 'sticky-note', library: 'lucide' };
    default:
      return { name: 'message-circle', library: 'lucide' };
  }
};

export const getConversationIcon = (channel: ConversationChannelTypeExtended): string =>
  getConversationIconConfig(channel).name;

export const getConversationIconLibrary = (
  channel: ConversationChannelTypeExtended,
): IconLibrary => getConversationIconConfig(channel).library ?? 'lucide';

// max height of conversation message until message becomes collapsed in rem
export const MAX_CONVERSATION_MESSAGE_HEIGHT_REM = 16;

// shared outer radius for every card/box type rendered inside the conversation timeline (10px)
export const CONVERSATION_CARD_BORDER_RADIUS = '0.625rem';

/*
 * 48px from a timeline row's outer edge to where its card starts. Every row type fills this
 * gutter differently — messages with the timestamp column, signal/triage rows with an icon plus
 * gap — so each derives its own offset from this one value instead of happening to agree.
 */
export const CONVERSATION_ROW_GUTTER = '3.75rem';

/*
 * 900px. Shared thread + composer column so they read as one centered column.
 * When the side panel becomes floating, revisit: centering will land on the open
 * space rather than the full pane, so this may feel less island-y without a bump.
 */
export const CONVERSATION_COLUMN_MAX_WIDTH = '56.25rem';
